import { Route } from '@angular/router';
import { authGuard } from '../guards/auth.guard';
import { LayoutComponent } from './layout/layout.component';
import ProductLayout from './layout/product/product.layout';
import { AdminRoutes } from './routes/admin.routes';
import { BreedRoutes } from './routes/breed.routes';
import { ComponentsRoutes } from './routes/components.routes';
import { CustomerRoutes } from './routes/customer.routes';
import { ProductRoutes } from './routes/product.routes';
import { SettlementRoutes } from './routes/settlement.routes';
import { SiteRoutes } from './routes/site.routes';
import { StatisticsRoutes } from './routes/stat.routes';
import { UserRoutes } from './routes/user.routes';
import { OrderRoutes } from './routes/order.routes';
import { FarmRoutes } from './routes/farm.routes';
import { ShopRoutes } from './routes/shop.routes';

export const appRoutes: Route[] = [
  {
    path: 'sign-in',
    loadComponent: () => import('./pages/auth/sign-in/sign-in.page'),
  },
  {
    path: 'sign-up',
    loadComponent: () => import('./pages/auth/sign-up/sign-up.page'),
  },
  {
    path: '',
    component: LayoutComponent,
    canActivateChild: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard.page'),
      },
      ...UserRoutes,
      ...CustomerRoutes,
      ...StatisticsRoutes,
      ...ComponentsRoutes,
      ...AdminRoutes,
      ...ProductRoutes,
      ...SettlementRoutes,
      ...OrderRoutes,
      ...FarmRoutes,
      ...BreedRoutes,
      ...SiteRoutes,
      {
        path: 'notification-batch',
        loadComponent: () =>
          import('./pages/notification-batch/notification-batch.page'),
      },
      {
        path: 'my-page',
        loadComponent: () => import('./pages/my-page/my-page.page'),
      },
    ],
  },
  ...ShopRoutes,
  {
    path: 'product/:productId',
    component: ProductLayout,
    canActivateChild: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        data: { title: '상품 대시보드' },
        loadComponent: () =>
          import('./pages/product/product-dashboard/product-dashboard.page'),
      },
      {
        path: 'pig',
        data: { title: '돼지 관리' },
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/product/pig/pig.page'),
          },
          {
            path: 'form',
            data: { title: '돼지 등록' },
            loadComponent: () =>
              import('./pages/product/pig/pig-form/pig-form.page'),
          },
          {
            path: 'form/:pigId',
            data: { title: '돼지 수정' },
            loadComponent: () =>
              import('./pages/product/pig/pig-form/pig-form.page'),
          },
          {
            path: ':pigId',
            data: { title: '돼지 상세' },
            loadComponent: () =>
              import('./pages/product/pig/pig-detail/pig-detail.page'),
          },
        ],
      },
      {
        path: 'order',
        data: { title: '판매 관리' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/product/product-order/product-order.page'),
          },
          {
            path: ':id',
            data: { title: '주문 상세' },
            loadComponent: () =>
              import('./pages/order/order-detail/order-detail.page'),
          },
        ],
      },
      {
        path: 'growth-gallery',
        data: { title: '갤러리 관리' },
        loadComponent: () =>
          import('./pages/product/growth-gallery/growth-gallery.page'),
      },
      {
        path: 'edit',
        data: { title: '상품 수정' },
        loadComponent: () =>
          import('./pages/product/product-form/product-form.page'),
      },
    ],
  },
];
